export const SENTRY_RELEASE: string | undefined = '8773eefc5d8481421c2a317651dcc78ddacfec4d';
